import resources from '../../assets/Ourapp/resourcesMobile.png'
import resourcesDesktop from '../../assets/Ourapp/resources.png'

interface ResourcesAccessProps {
  isMobile: boolean
}

const ResourcesAccess = ({ isMobile = false }: ResourcesAccessProps) => {
  if (isMobile) {
    return (
      <div className='w-full h-[642.001px] relative'>
        <div className='w-[200px] h-[200px]  bg-[#25395C] blur-[60px] absolute top-0 right-0'></div>
        <div className='h-[612px] bg-white/5 backdrop-blur-[100px] border-box '>
          <div className='pt-[31px] ml-auto  mr-[27px] w-[176px] h-[97px] mb-9'>
            <h2 className='text-white text-center font-bold tracking-wide text-base leading-6'>
              All your resources in one place,
              <br />
              <span className='text-[#E3FFFB]'>
                so you can get back to what matters.
              </span>
            </h2>
          </div>

          <img src={resources} className='w-[335px] h-[417px] mx-auto pt-5' />
        </div>
      </div>
    )
  }
  return (
    <div className='w-full relative lg:h-auto 2xl:h-[1117px]'>
      <div
        className='lg:w-[563.3px] lg:h-[600px] lg:rounded-[600px] lg:blur-[150px]
        xl:w-[657.2px] xl:h-[700px] xl:rounded-[700px] xl:blur-[175px]
        2xl:w-[751.1px] 2xl:h-[800px] 2xl:rounded-[800px] 2xl:blur-[200px]
        3xl:w-[938.875px] 3xl:h-[1000px] 3xl:rounded-[1000px] 3xl:blur-[250px]
        bg-[#25395C] flex-shrink-0 absolute top-0 right-0'
      ></div>

      <div
        className='flex flex-shrink-0 justify-between items-center  rounded-l-none bg-white/30
        lg:w-[960.81px] lg:h-[541.53px] lg:px-[53.3px] lg:py-[32px] lg:rounded-r-[21.32px] lg:backdrop-blur-[100px]
        xl:w-[1202.24px] xl:h-[677.67px] xl:px-[66.7px] xl:py-[40px] xl:rounded-r-[26.68px]
        2xl:w-[1442.11px] 2xl:h-[812.8px] 2xl:px-[80px] 2xl:py-[48px] 2xl:rounded-r-[32px] 
        3xl:w-[1802.641px] 3xl:h-[1016px] 3xl:px-[100px] 3xl:py-[60px] 3xl:rounded-r-[40px]'
      >
        <div className='flex-shrink-0'>
          <img
            src={resourcesDesktop}
            className='w-[335px] h-[417px]  lg:w-[483px] lg:h-[600px] xl:w-[603px] xl:h-[750px] 2xl:w-[684px] 2xl:h-[850px] 3xl:w-[721px] 3xl:h-[896px]'
          />
        </div>
        <div>
          <h2
            className='text-white text-center font-bold tracking-wide leading-6 lg:text-xl lg:leading-8 xl:text-3xl xl:leading-10 
              2xl:text-4xl 3xl:text-[40px] 3xl:leading-none'
          >
            All your resources in one place,
            <br />
            <span
              className='text-[#E3FFFB] text-center font-medium  leading-6 tracking-wide lg:text-lg lg:font-semibold lg:leading-7 xl:text-2xl xl:leading-8 2xl:text-[#B8E0DB] 2xl:text-3xl 2xl:font-bold 2xl:leading-none
  '
            >
              so you can get back to what matters.
            </span>
          </h2>
        </div>
      </div>
    </div>
  )
}

export default ResourcesAccess
